import { Component, Input } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { GlobalFormGroup } from '@app/services/formulario';
import { convertErrorsNz } from '@app/utiles/ng-zorro';

@Component({ standalone: false, selector: 'app-form-reactive-input',
  templateUrl: './reactive-input.component.html',
})
export class FormReactiveInput<T> {
  private static nextId = 0;
  @Input() label: string = '';
  @Input() inputType: string = 'text';
  @Input() required = false;
  @Input() labelClass: string = '';
  @Input() secondLabel: string = '';
  @Input() secondLabelClass: string = '';
  @Input() inputId = `field-${FormReactiveInput.nextId++}`;
  @Input() inputFormControl: GlobalFormGroup<T> = null;
  readonly convertErrorsNz = convertErrorsNz;
  // Necesario para evitar el error de tipado para [formControl] (https://github.com/ngx-formly/ngx-formly/issues/2842)
  readonly asFormControl = (formControl: AbstractControl): FormControl => formControl as FormControl;
}
